export const ROLE = {
  master: 1,
  creative: 2,
  normal: 3,
  light: 4,
  lowest: 5,
};

export const CLASSIFICATION = {
  high_school: "高校",
  junior_high_school: "中学",
  other_school: "その他",
};

export const APP = {
  dlp: "DLP",
  g4s: "GearForSchool",
  onemenu: "onemenu",
};

export const MIN_ENTRANCE_YEAR = 2018;

export const MAX_ENTRANCE_YEAR = new Date().getFullYear() + 1;

export const IMAGE_TYPE = {
  vertical: 1,
  horizontal: 2,
};

export const SCHOOL_DOCUMENT_TYPE = {
  delivery_and_invoice: "納品書 兼 請求書",
  invoice: "請求書",
  delivery: "納品書",
  receipt: "領収書",
};

// 書類一覧の絞り込み(APIの category と対応)。
// 「納品書 兼 請求書」は1枚で両方の役割を果たすため請求書にも納品書にも現れる
export const SCHOOL_DOCUMENT_CATEGORY = {
  invoice: SCHOOL_DOCUMENT_TYPE.invoice,
  delivery: SCHOOL_DOCUMENT_TYPE.delivery,
  receipt: SCHOOL_DOCUMENT_TYPE.receipt,
};
